import { createFileRoute, Outlet } from '@tanstack/react-router'

import { requireInternal } from '@/auth/guards'
import { AppHeader } from '@/components/layout/app-header'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { setCurrentLocale } from '@/i18n'

export const Route = createFileRoute('/_app')({
  beforeLoad: requireInternal,
  component: AppLayout,
})

function AppLayout() {
  // Lot 34 : l'équipe lit le français, même après un passage au portail dans cet onglet.
  setCurrentLocale('fr')
  return (
    <div className="flex min-h-dvh">
      <AppSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <AppHeader />
        {/* Pleine largeur, pour tout écran : listes, tableaux de bord et fiches.
            Une fiche ne se plafonne pas (#249) ; seuls les textes longs gardent
            leur propre largeur de lecture. */}
        <main className="flex-1 px-3 py-4 sm:px-6 sm:py-5 lg:px-8 xl:px-10">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
